import { useEffect } from "react";
import { useParams } from "react-router";

import { useUpdateStepStatus } from "@/features/procedures/api/checklist.mutations";
import { ProcedureNodeStep } from "@/features/procedures/model/types/checklist";
import { UpdateStepStatusRequest } from "@/features/procedures/model/types/checklist";
import { CheckpointType } from "@/features/procedures/model/types/manualChecklist";

import { RouteParams } from "@/service/Utilities";

export const useTryUpdateLiveStep = (
	step: ProcedureNodeStep,
	isActiveStep: boolean,
) => {
	const { id, schemeId } = useParams<RouteParams>();
	const procedureId = parseInt(id);
	const checklistId = parseInt(schemeId);
	const updateStepState = useUpdateStepStatus();

	useEffect(() => {
		if (
			isNaN(procedureId) ||
			isNaN(checklistId) ||
			!isActiveStep ||
			step.CheckpointType !== CheckpointType.SATOSLive ||
			step.Status
		)
			return;

		const allListenerTagsSaved = step.ListenerTags.every(
			(x) => x.SavedTagValue !== null && x.SavedTagValue !== undefined,
		);
		if (!allListenerTagsSaved) {
			return;
		}

		const handleUpdateStepStatus = async () => {
			try {
				const request: UpdateStepStatusRequest = {
					ArchiveType: "Status",
					StepId: step.Id,
					ProcedureId: procedureId,
					SchemeId: checklistId,
					File: null,
					Status: 1,
					Metadata: { ...step, Status: 1 },
				};

				await updateStepState(request);
			} catch (error) {
				console.warn(error);
			}
		};

		handleUpdateStepStatus();
	}, [step, isActiveStep]);
};
